import PagingButton from "./PagingButton";

export default PagingButton;
